let Backbone = require("backbone");

let main = function (Backbone) {
    return Backbone.Model.extend({
        defaults: {
            categories: null
        },

        getCategories: function () {
            return this.get("categories");
        },

        getCategory: function (categoryId) {
            return this.getCategories().get(categoryId);
        },

        setCategories: function (categories) {
            this.set("categories", categories);
        }

    });
};

let exportedValue = main(Backbone);
export default exportedValue;


// WEBPACK FOOTER //
// ./src/model/MenuModel.js